import WordAnalogies from './WordAnalogies'

export default WordAnalogies
